module.exports = __webpack_public_path__ + "static/media/Fandom.e47dc065.jpeg";